/**
 * Scene visibility management
 * Handles showing/hiding scenes with animations
 */

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export interface SceneVisibilityContext {
  container: HTMLDivElement
  fadeInAnimation: gsap.core.Tween | null
  setFadeInAnimation: (animation: gsap.core.Tween | null) => void
}

/**
 * Show scene with optional animation
 */
export function showScene(context: SceneVisibilityContext, animate: boolean = true): void {
  if (animate) {
    gsap.set(context.container, { opacity: 0 })

    const startTrigger = 'top 100%'

    const fadeInAnimation = gsap.to(context.container, {
      opacity: 1,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: context.container,
        start: startTrigger,
        end: 'top 50%',
        toggleActions: 'play none none none',
        once: true,
        invalidateOnRefresh: true,
        onEnter: () => {
          gsap.set(context.container, { opacity: 1 })
        },
        onEnterBack: () => {
          gsap.set(context.container, { opacity: 1 })
        },
      },
    })

    context.setFadeInAnimation(fadeInAnimation)
  } else {
    gsap.set(context.container, { opacity: 1 })
  }
}
